import { createAsyncThunk } from "@reduxjs/toolkit";
import { createContractLoginApi } from "../../../api";
import type {
  ProblemDetails,
  TokenViewModel,
} from "../../../api/axcloud";
import {
  clearStoredAccessToken,
  persistAccessToken,
  readStoredAccessToken,
} from "../services/tokenStorage";
import { getProblemDetails } from "./helpers";
import type { LoginThunkConfig } from "./types";

interface ContractLoginArgs {
  contractId: string;
  password: string;
}

/**
 * 契約IDとパスワードを使用してログインします。
 */
export const contractLogin = createAsyncThunk<
  TokenViewModel,
  ContractLoginArgs,
  LoginThunkConfig
>(
  "login/contractLogin",
  async (arg, thunk) => {
    const api = createContractLoginApi();
    try {
      const response = await api.contractLogin({
        contractId: arg.contractId,
        password: arg.password,
      });

      // 2FAが必要な場合は、認証完了まで一時トークンをRedux stateだけで保持する。
      persistAccessToken(response.data);

      return response.data;
    } catch (error) {
      const problem = getProblemDetails(error);
      if (problem) {
        return thunk.rejectWithValue(problem);
      }
      throw error;
    }
  }
);

/**
 * 保存されているアクセストークンを使用して自動ログインを試みます。
 */
export const autoLogin = createAsyncThunk<
  TokenViewModel,
  void,
  LoginThunkConfig
>(
  "login/autoLogin",
  async (_arg, thunk) => {
    const token = readStoredAccessToken();
    if (token) {
      return token;
    }

    const details: ProblemDetails = {
      detail: "アクセストークンが保存されていません。",
    };
    return thunk.rejectWithValue(details);
  }
);

/**
 * ログアウトします。
 */
export const logout = createAsyncThunk<void, void>(
  "login/logout",
  () => {
    clearStoredAccessToken();
  }
);
